
import { supabase } from "@/integrations/supabase/client";
import { SwapRequest } from "@/services/myReagents/types";

export const fetchSwapRequestById = async (id: string) => {
  try {
    // Query with correct relationship hints using the ! operator
    const { data, error } = await supabase
      .from("swap_requests")
      .select(`
        id,
        reagent_id,
        requester_id,
        status,
        credit_offer,
        offered_reagent_id,
        created_at,
        updated_at,
        reagents!reagent_id(
          id,
          name,
          catalogue_number,
          amount,
          amount_unit,
          storage_conditions,
          image_url,
          user_id
        ),
        profiles!requester_id(
          username,
          lab,
          university
        ),
        offered_reagents(
          id,
          name,
          catalogue_number,
          amount,
          amount_unit,
          storage_conditions,
          description
        )
      `)
      .eq("id", id)
      .single();
      
    if (error) {
      console.error("Error fetching swap request:", error);
      throw error;
    }
    
    // If there's an offered_reagent_id, fetch it separately
    let offeredReagent = null;
    if (data.offered_reagent_id) {
      try {
        const { data: reagentData, error: reagentError } = await supabase
          .from("reagents")
          .select(`
            id,
            name,
            catalogue_number,
            amount,
            amount_unit,
            storage_conditions,
            image_url
          `)
          .eq("id", data.offered_reagent_id)
          .single();
          
        if (!reagentError && reagentData) {
          offeredReagent = reagentData;
        }
      } catch (innerError) {
        console.error("Error fetching offered reagent:", innerError);
        // Continue execution even if offered reagent fetch fails
      }
    }
    
    // Combine the results
    return {
      ...data,
      offered_reagent: offeredReagent
    };
  } catch (error) {
    console.error("Exception in fetchSwapRequestById:", error);
    throw error;
  }
};
